import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  Button,
  Table,
  Form,
  Input,
  InputNumber,
  Modal,
  message,
  Cascader,
  Row,
  Col,
} from "antd";
import RenderTxt from "@components/renderTxt";
import SystemApi from "@api/sys";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import SearchForm from "@components/SearchForm";
import stationApi from "@api/station";
import moment from "moment";
import { findAllParents } from "@utils/common";

const fieldNames = {
  label: "itemName",
  value: "id",
  children: "children",
};

const layout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 20 },
};

const layout1 = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
};

const BomRecord = ({ userInfo }) => {
  let stationId = "-1";
  if (userInfo.stationIds) {
    userInfo.stationIds.includes(",")
      ? (stationId = userInfo.stationIds.split(",")[0])
      : (stationId = userInfo.stationIds);
  }
  const [form] = Form.useForm();
  const [visible, setVisible] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [editId, setEditId] = useState();
  const [loading, setLoading] = useState(false);
  const [searchParams, setSearchParams] = useState({
    pageNum: 1,
    pageSize: 10,
  });
  const [tableSource, setTableSource] = useState({});
  const [deviceList, setDeviceList] = useState([]);
  const [inputList] = useState([
    {
      label: "父级设备名称:",
      name: "parentName",
      message: "请输入父级设备名称",
      span: 10,
      labelCol: 6,
    },
  ]);

  const expandedRowRender = (record) => {
    const columns = [
      {
        title: "BOM版本",
        dataIndex: "bomVersion",
        key: "bomVersion",
        align: "center",
        render: (text) => RenderTxt(text),
      },
      {
        title: "设备名称",
        dataIndex: "childName",
        key: "childName",
        align: "center",
        render: (text) => RenderTxt(text),
      },
      {
        title: "创建时间",
        dataIndex: "createAt",
        key: "createAt",
        align: "center",
        render: (text) => RenderTxt(moment(text).format("YYYY-MM-DD HH:mm:ss")),
      },
      {
        title: "损耗率",
        dataIndex: "lossRate",
        key: "lossRate",
        align: "center",
        render: (text) => RenderTxt(text),
      },
      {
        title: "使用量",
        dataIndex: "quantity",
        key: "quantity",
        align: "center",
        render: (text) => RenderTxt(text),
      },
      {
        title: "排序",
        dataIndex: "sort",
        key: "sort",
        align: "center",
        render: (text) => RenderTxt(text),
      },
      {
        title: "操作",
        dataIndex: "action",
        align: "center",
        key: "action",
        render: (text, obj) => {
          return (
            <>
              <Button type="primary" onClick={() => editRecord(obj, record)}>
                编辑
              </Button>
              <Button
                style={{ marginLeft: 8 }}
                type="primary"
                onClick={() => delRecord(obj.id)}
                danger
              >
                删除
              </Button>
            </>
          );
        },
      },
    ];
    record.childrenList.map((item) => {
      item.key = item.id;
    });
    return (
      <Table
        columns={columns}
        dataSource={record.childrenList}
        pagination={false}
        bordered
      />
    );
  };

  const columns = [
    {
      title: "父级设备名称",
      dataIndex: "parentName",
      align: "center",
      key: "parentName",
      render: (text) => RenderTxt(text),
    },
  ];

  useEffect(() => {
    getDevice();
  }, []);

  useEffect(() => {
    getListPages();
  }, [searchParams]);

  const addRecord = () => {
    setVisible(true);
    form.setFieldsValue({
      childrenList: [{}],
    });
  };

  const getDevice = () => {
    stationApi.getDeviceByStationId({ stationId }).then((res) => {
      if (res.status !== "0") return;
      const ls = getTreeData(res.data);
      setDeviceList(ls);
    });
  };

  const getTreeData = (data) => {
    return data.map((item) => {
      return {
        ...item,
        id: item.deviceId ? item.deviceId : item.id,
        children: item.child.length ? getTreeData(item.child) : undefined,
        child: undefined,
      };
    });
  };

  const getListPages = () => {
    setLoading(true);
    SystemApi.bomInfoList(searchParams).then((res) => {
      setLoading(false);
      if (res.status !== "0") return;
      const { data } = res.data;
      data.map((item, index) => {
        item.key = index + 1;
      });
      setTableSource(res.data);
    });
  };

  const delRecord = (id) => {
    Modal.confirm({
      onOk: () => {
        SystemApi.bomInfoRemove({ id }).then((res) => {
          if (res.status !== "0") return;
          message.success("删除成功");
          getListPages();
        });
      },
      title: "请确认",
      icon: <ExclamationCircleOutlined />,
      content: "是否删除",
      okText: "确认",
      cancelText: "取消",
    });
  };

  const editRecord = (obj, parent) => {
    const { id, lossRate, quantity, sort, bomVersion } = obj;
    setVisible(true);
    setEditId(id);
    const parentId = findAllParents(
      deviceList,
      parent.parentId * 1,
      [],
      "number",
      "children"
    );
    const childId = findAllParents(
      deviceList,
      obj.childId * 1,
      [],
      "number",
      "children"
    );
    form.setFieldsValue({
      bomVersion,
      parentId,
      childrenList: [
        {
          childId,
          lossRate,
          quantity,
          sort,
        },
      ],
    });
  };

  const cancel = () => {
    setVisible(false);
    form.resetFields();
    setEditId(null);
  };

  const save = () => {
    form.validateFields().then((values) => {
      const params = {
        ...values,
        parentId: values.parentId.at(-1),
        childrenList: values.childrenList.map((item) => {
          return {
            childId: item.childId.at(-1),
            lossRate: item.lossRate,
            quantity: item.quantity,
            sort: item.sort,
          };
        }),
      };
      if (editId) {
        setConfirmLoading(true);
        const editParams = {
          ...params,
          ...params.childrenList[0],
          id: editId,
        };
        delete editParams.childrenList;
        SystemApi.bomInfoUpdate(editParams).then((res) => {
          setConfirmLoading(false);
          if (res.status !== "0") return;
          message.success("修改成功");
          cancel();
          getListPages();
        });
      } else {
        setConfirmLoading(true);
        SystemApi.bomInfoSave(params).then((res) => {
          setConfirmLoading(false);
          if (res.status !== "0") return;
          message.success("新增成功");
          cancel();
          getListPages();
        });
      }
    });
  };

  const handleTableChange = (pagination) => {
    const params = {
      ...searchParams,
      pageNum: pagination.current,
      pageSize: pagination.pageSize,
    };
    setSearchParams(params);
  };

  const search = (values) => {
    const params = {
      ...values,
      pageNum: 1,
      pageSize: 10,
    };
    setSearchParams(params);
  };

  return (
    <div style={{ padding: 20 }}>
      <SearchForm span={6} inputList={inputList} onSearch={search} />
      <Button
        type="primary"
        style={{ marginBottom: "10px" }}
        onClick={addRecord}
      >
        新增
      </Button>
      <Table
        bordered
        loading={loading}
        columns={columns}
        expandable={{
          expandedRowRender,
          defaultExpandedRowKeys: ["0"],
        }}
        dataSource={tableSource.data}
        pagination={{
          current: tableSource.pageNum,
          pageSize: tableSource.pageSize,
          showQuickJumper: true,
          showSizeChanger: true,
          showTotal: (total) => `共${total}条数据`,
          total: tableSource.total * 1,
        }}
        onChange={handleTableChange}
      />
      {visible && (
        <Modal
          title={editId ? "编辑" : "新增"}
          open={visible}
          onCancel={cancel}
          onOk={save}
          confirmLoading={confirmLoading}
          width={800}
        >
          <Form {...layout} form={form}>
            <Form.Item
              label="BOM版本"
              name="bomVersion"
              rules={[{ required: true, message: "请输入BOM版本!" }]}
            >
              <Input placeholder="请输入BOM版本" />
            </Form.Item>
            <Form.Item
              label="父项设备"
              name="parentId"
              rules={[{ required: true, message: "请选择父项设备!" }]}
            >
              <Cascader
                fieldNames={fieldNames}
                options={deviceList}
                placeholder="请选择父项设备"
              />
            </Form.Item>
            <Form.List name="childrenList">
              {(fields, { add, remove }) => (
                <Row>
                  {fields.map((field) => (
                    <Col
                      offset={2}
                      style={{
                        marginTop: 10,
                        marginBottom: 10,
                        paddingBottom: 10,
                        borderBottom: "1px solid #ddd",
                      }}
                      span={20}
                      key={field.key}
                    >
                      <Row gutter={20}>
                        <Col span={20}>
                          <Row>
                            <Col span={12}>
                              <Form.Item
                                {...layout1}
                                label="子项设备"
                                name={[field.name, "childId"]}
                                rules={[
                                  {
                                    required: true,
                                    message: "请选择子项设备!",
                                  },
                                ]}
                              >
                                <Cascader
                                  fieldNames={fieldNames}
                                  options={deviceList}
                                  placeholder="请选择子项设备"
                                />
                              </Form.Item>
                            </Col>
                            <Col span={12}>
                              <Form.Item
                                {...layout1}
                                label="损耗率"
                                name={[field.name, "lossRate"]}
                                rules={[
                                  { required: true, message: "请填写损耗率!" },
                                ]}
                              >
                                <InputNumber
                                  style={{ width: "100%" }}
                                  placeholder={"请填写损耗率"}
                                />
                              </Form.Item>
                            </Col>
                            <Col span={12}>
                              <Form.Item
                                {...layout1}
                                label="使用量"
                                name={[field.name, "quantity"]}
                                rules={[
                                  { required: true, message: "请填写使用量!" },
                                ]}
                              >
                                <InputNumber
                                  style={{ width: "100%" }}
                                  placeholder={"请填写使用量"}
                                />
                              </Form.Item>
                            </Col>
                            <Col span={12}>
                              <Form.Item
                                {...layout1}
                                label="排序"
                                name={[field.name, "sort"]}
                                rules={[
                                  { required: true, message: "请填写排序!" },
                                ]}
                              >
                                <InputNumber
                                  style={{ width: "100%" }}
                                  placeholder={"请填写排序"}
                                />
                              </Form.Item>
                            </Col>
                          </Row>
                        </Col>
                        <Col span={4}>
                          {fields.length > 1 && (
                            <Button
                              type="dashed"
                              onClick={() => remove(field.name)}
                            >
                              移除
                            </Button>
                          )}
                        </Col>
                      </Row>
                    </Col>
                  ))}
                  {!editId && (
                    <Col
                      span={2}
                      style={{
                        textAlign: "right",
                        marginTop: 10,
                        marginBottom: 10,
                        paddingBottom: 10,
                      }}
                    >
                      <Button type="dashed" onClick={add}>
                        添加
                      </Button>
                    </Col>
                  )}
                </Row>
              )}
            </Form.List>
          </Form>
        </Modal>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    ...state.Common,
  };
};

export default connect(mapStateToProps)(BomRecord);
